import icon from './top_publishers.png.js';
import {
    defaultShortNumberFormatter,
    MW_VISUALIZATIONS_BASE_MODULE_NAME,
    MwChartOneSeriesBarOptions,
    percentageFormatter,
    SeriesData,
} from '@meltwater/mw-visualizations-angularjs';
import template from './graph_widget_view.html';
import templateMaxView from './graph_widget_max.html';
import templateReportView from './graph_widget_report.html';

function getTooltipString({ key, value }, data) {
    const [{ percent }] = data.filter(point => point.key === key);
    return `${key}: ${defaultShortNumberFormatter(value)} (${percentageFormatter(percent)}%)`;
}

function deDupeCategoriesAndMapData(dataArray) {
    const categoryMap = {};
    return dataArray.map(dataPoint => {
        let key = dataPoint.category;
        if (!categoryMap[dataPoint.category]) {
            categoryMap[dataPoint.category] = 1;
        } else {
            key += ` (${categoryMap[dataPoint.category]})`;
            categoryMap[dataPoint.category] += 1;
        }
        return {
            key,
            value: dataPoint.volume,
            percent: dataPoint.percent
        };
    });
}

function shouldAnimateVisualization() {
    return !/wkhtmlto/i.test(navigator.userAgent);
}

angular.module('MW.InsDashboard.sourceSegmentWidget', [
    'MW.Framework.TranslationService',
    'MW.Dashboard.DashboardWidgetService',
    'MW.InsDashboard.insightsBackendService',
    'DashboardChartConfigService',
    'MW.Framework.GeoService',
    'MW.InsDashboard.InsWidgetConfigService',
    'MW.InsDashboard.InsightsDataMaps',
    'MW.InsDashboard.TransformSegment',
    'MW.InsDashboard.ChartDataService',
    'MW.Framework.CoreCommon',
    'CoreChartObject',
    'CoreColorService',
    'MW.Dashboard.DashboardStateService',
    'MW.Framework.CoreBreadcrumb',
    'MW.Framework.CoreSourceService',
    'MW.Framework.AppChromeService',
    'MW.Configuration',
    'MW.Dashboard.Base64Service',
    'MW.DashboardLegacy.Constants',
    'MW.Dashboard.ShareableDashboardsAdditionalData',
    MW_VISUALIZATIONS_BASE_MODULE_NAME
]).directive('sourceSegmentWidget', [
    '$q',
    'translationService',
    'DashboardWidgetService',
    '$filter',
    'insightsBackendService',
    'DashboardChartConfigService',
    'GeoService',
    'InsWidgetConfigService',
    'InsightsDataMaps',
    'TransformSegment',
    'ChartDataService',
    'CoreCommon',
    'CoreChartObject',
    'CoreColorService',
    'DashboardStateService',
    '$routeParams',
    '$location',
    'Breadcrumb',
    'CoreSourceService',
    '$timeout',
    'Base64Service',
    'ShareableDashboardsAdditionalData',
    function(
        $q,
        translationService,
        DashboardWidgetService,
        $filter,
        insightsBackendService,
        DashboardChartConfigService,
        GeoService,
        InsWidgetConfigService,
        InsightsDataMaps,
        TransformSegment,
        ChartDataService,
        CoreCommon,
        CoreChartObject,
        CoreColorService,
        DashboardStateService,
        $routeParams,
        $location,
        Breadcrumb,
        CoreSourceService,
        $timeout,
        Base64Service,
        ShareableDashboardsAdditionalData
){
    var sourceSegmentWidget = DashboardWidgetService.getWidget('source-segment-widget');

    var sourceSegmentWidgetController = function($scope){
        $scope.insightsService = 'sourceHistograms';

        $scope.initSettings = function(){
            InsWidgetConfigService.readyWidgetData($scope);
            if($scope.widget.settings.selectedGraphType.id === 'table' && $scope.isReport) {
                $scope.graphType = 'table';
            }
        };

        $scope.getMwApi = (mwAPI) => {
            $scope.$on('widgetResized', function onChartResize() {
                mwAPI.redraw();
            });
        };
    };

    var sourceSegmentWidgetLink = function(scope, element) {

        scope.mwOneSeriesBarChartData = [];
        scope.mwOneSeriesBarChartOptions = {};

        var getLabelFormatFromSettings = function getLabelFormatFromSettings() {
                return CoreCommon.isUsable(scope.widget.settings.labelFormat) ? scope.widget.settings.labelFormat[0].id : scope.widget.availableLabelFormat[0].id;
            },
            defaultGraph = scope.widget.availableChartTypes[0].id,
            defaultColors = CoreColorService.getColors('default'),
            inputColor = CoreColorService.colors.blueMalibu;

        if(scope.widget.settings.searchIds && scope.widget.settings.searchIds.length === 1) {
            var encodedInputId = Base64Service.encode(scope.widget.settings.searchIds[0].searchId);

            if(typeof DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] === 'undefined') {
                inputColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] = defaultColors[DashboardStateService.inputIdsToColorMapping.colorIndex++];
            } else {
                inputColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId];
            }
        } else if(scope.widget.settings.inputs && scope.widget.settings.inputs.length === 1) {
            var encodedInputId = Base64Service.encode(scope.widget.settings.inputs[0].id);

            if(typeof DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] === 'undefined') {
                inputColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] = defaultColors[DashboardStateService.inputIdsToColorMapping.colorIndex++];
            } else {
                inputColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId];
            }
        }

        var getLabelVisibilityFromSettings = function getLabelVisibilityFromSettings() {
            return CoreCommon.isUsable(scope.widget.settings.labelVisibility) ? scope.widget.settings.labelVisibility[0].id : scope.widget.availableLabelVisibility[0].id;
        };
        scope.labelVisibility = (getLabelVisibilityFromSettings() == 1) ? false : true;

        var sourceIdMap = {};

        scope.widgetIsLoading = false;
        scope.noDataFromServer = false;
        scope.serviceError=false;
        scope.showTable = false;
        scope.notConfigured = false;
        scope.searches = [];
        scope.documentRequest = {};
        scope.graphType = defaultGraph;
        scope.drillDown = InsWidgetConfigService.dateGranularityDrilldown;
        scope.widget.settings.chart = {
            xAxisType: "category"
        };
        scope.tableSettings = {
            enabled: true,
            data: {},
            rowTitle: 'Publications',
            summaryTitle: translationService.getLocalizedString('Total'),
            countField: 'count',
            percentField: 'percent',
            titleField: 'name'
        };
        scope.selectedLabelFormatId = getLabelFormatFromSettings(); // Getting Label Format id from widget.settings

        if(scope.selectedLabelFormatId == 1) { // Number
            scope.widget.settings.chart.percentageMode = false;
        } else if (scope.selectedLabelFormatId == 2) { // Percentage
            scope.widget.settings.chart.percentageMode = true;
        }

        // Run our updating function when we recieve an update notification from a widget higher in the scope tree.
        scope.$on('widgetFiltersUpdated', function() { scope.fetchData(true) });

        function initMwBarChart(dataFromService) {
            const yAxisTitle = 'Results';

            try {
                // Add additional information required for shareable dashboards
                var search = Object.assign(scope.widget.settings.inputs[0], {
                    color: inputColor
                });
                var sources = dataFromService.series[0].data.map(function(element) {
                    return {
                        sourceId: element.sourceId,
                        name: element.category
                    };
                });

                var additionalData = {
                    search: search,
                    sources: sources
                };

                ShareableDashboardsAdditionalData.addAdditionalData({
                    key: scope.widget.id,
                    data: additionalData
                });
            } catch(error) {
                console.error('Something went wrong gathering additional data for top sources Shareable dashboards');
                console.error(error);
            }

            let mapData = deDupeCategoriesAndMapData(dataFromService.series[0].data);
            let yAxisLabelFormatter = options => {
                if (options.value % 1 !== 0) {
                    return null
                }
                return defaultShortNumberFormatter(options.value);
            }

            if(!scope.isMaximized) {
                mapData = mapData.slice(0, 6);

                yAxisLabelFormatter = options => {
                    if (options.isFirst || options.isLast) {
                        return defaultShortNumberFormatter(options.value);
                    }
                }
            }

            const labelFormatterHandler = (point) => {
                if(!scope.labelVisibility) {
                    return `${point.key}`;
                }
                return `${point.key} — ${defaultShortNumberFormatter(point.value)}`;
            };

            const seriesName = scope.inputs[0].name;
            const oneSeriesData = new SeriesData({ name: seriesName, data: mapData });
            scope.mwOneSeriesBarChartData = oneSeriesData;

            scope.mwOneSeriesBarChartOptions = new MwChartOneSeriesBarOptions({
                animate: shouldAnimateVisualization(),
                barLabelFormatter: labelFormatterHandler,
                barColorFormatter: () => inputColor,
                showSummaryYAxis: !scope.isMaximized,
                tooltipFormatter: point => getTooltipString(point, mapData),
                yAxisTitle: translationService.getLocalizedString(yAxisTitle),
                yAxisLabelFormatter: yAxisLabelFormatter,
                onBarClick: (event) => {
                    const { sourceId }  = dataFromService.series[0].data.filter(series => series.category === event.key).shift();
                    scope.internalDrillDown(scope.inputs[0].id, sourceId, event.key);
                }
            });
            scope.showMwVizBarChart = true;
        }

        scope.fetchData = function fetchDataAndRenderChart() {
            var graphInitialLoad = true;
            var createSourceIdMap = function createSourceIdMap(data){
                var datapoints = data.series[0].data;

                for (var i = 0; i < datapoints.length; i++) {
                    sourceIdMap[datapoints[i].sourceId] = datapoints[i].category;
                }
            };

            var processData = function processData(data) {
                scope.widgetIsLoading=false;
                scope.chartData = {};

                var sharedChart,
                    viewName = 'user';
                if(scope.isReport){
                    viewName = 'report';
                } else if(scope.isMaximized){
                    viewName = 'max';
                }
                var chartBasics = {
                    type: defaultGraph,
                    view: viewName,
                    percent: scope.widget.settings.chart.percentageMode,
                    reportType: scope.reportType
                };


                var doChartAnimation = InsWidgetConfigService.getChartAnimationStatus(scope.widget.id+scope.isMaximized);

                var sharedChart = {
                    xAxis: {
                        labels: {
                            align: 'left',
                            x: 6,
                            y: 5,
                            style: {
                                color: CoreColorService.colors.grey80,
                                whiteSpace: 'nowrap'
                            },
                            useHTML: true,
                            formatter: function() {
                                var chartWidth = this.chart.clipBox.height,
                                    ourWidth = 0.65 * chartWidth;
                                var retVal = translationService.getLocalizedString(this.value);
                                retVal = DashboardChartConfigService.getTruncatedText(retVal, ourWidth, this.chart.userOptions.xAxis.labels.style);

                                var currentIdx = 0;
                                for (var idx = 0, max = this.axis.categories.length; idx < max; idx++){
                                    if (this.axis.categories[idx] == this.value){
                                        currentIdx = idx;
                                        break;
                                    }
                                }
                                var template, dataLabel;
                                if(scope.widget.settings.chart.percentageMode)
                                    dataLabel = data.series[0].data[currentIdx].percent.toFixed(2) + '%';
                                else
                                    dataLabel = DashboardChartConfigService.formatDataLabels(data.series[0].data[currentIdx].volume);

                                if(scope.labelVisibility) {
                                    template = '<div style="font-size: 11px; text-align: left; text-shadow: rgb(255, 255, 255) 0px 0px 6px, rgb(255, 255, 255) 0px 0px 3px; padding: 1px; margin-top: -2px;">'
                                        + retVal + '&nbsp;&mdash;&nbsp;' + dataLabel
                                        + '</div>';
                                } else {
                                    template = '<div style="font-size: 11px; text-align: left; text-shadow: rgb(255, 255, 255) 0px 0px 6px, rgb(255, 255, 255) 0px 0px 3px; padding: 1px; margin-top: -2px;">' + retVal + '</div>';
                                }

                                return template;
                            }
                        }
                    }
                };

                scope.chartData = CoreCommon.mergeRecursive(scope.chartData, sharedChart);


                if (scope.isMaximized) {
                    var maximizedChart = {

                        chart: {
                            marginRight: 13,
                            animation: false
                        },
                        tooltip: {
                            borderWidth: 2,
                            shape: 'square',
                            backgroundColor: 'rgba(255,255,255,0)',
                            borderRadius: 2,
                            style: {
                                padding: 0,
                                margin: 0
                            },
                            shadow: true,
                            useHTML: true,
                            percentageDecimals: 2,
                            backgroundColor: 'rgba(255,255,255,1)',
                            formatter: function () {
                                return InsWidgetConfigService.getBarTooltipValue(this, this.point.category == null ? translationService.getLocalizedString("Unknown Source") : this.point.category, {percentageMode: scope.widget.settings.chart.percentageMode});
                            }
                        },
                        yAxis: {
                            gridLineWidth: 1,
                            max: scope.widget.settings.chart.percentageMode ? 100 : null,
                            title: {
                                text: translationService.getLocalizedString('Results'),
                                offset: 30,
                                align: 'middle'
                            },
                            labels: {
                                useHTML: true,
                                formatter: InsWidgetConfigService.getSegmentationYAxisFormatFunction(scope.widget.settings.chart),
                                overflow: 'justify'
                            }
                        },
                        legend: {
                            enabled: false
                        },
                        plotOptions: {
                            bar: {
                                color: inputColor,
                                pointWidth: 28,
                                point: {
                                    events: {
                                        click: function() {
                                            scope.internalDrillDown(scope.inputs[0].id, this.sourceId, this.category);
                                        }
                                    }
                                }
                            },
                            series: {
                                animation: doChartAnimation
                            }
                        }
                    };
                    scope.chartData = CoreCommon.mergeRecursive(scope.chartData, maximizedChart);
                    scope.chartData = CoreCommon.mergeRecursive(scope.chartData, data);
                } else {

                    //dashboard view
                    var baseChart = {
                        chart: {
                            spacingLeft: 0,
                            spacingTop: 0,
                            marginRight: 12
                        },
                        tooltip: {
                            borderWidth: 2,
                            shape: 'square',
                            backgroundColor: "rgba(255,255,255,0)",
                            borderRadius: 2,
                            style: {
                                padding: 0,
                                margin: 0
                            },
                            shadow: true,
                            useHTML: true,
                            percentageDecimals: 2,
                            backgroundColor: "rgba(255,255,255,1)",
                            formatter: function () {
                                return InsWidgetConfigService.getBarTooltipValue(this, this.point.category == null ? translationService.getLocalizedString("Unknown Source") : this.point.category, {percentageMode: scope.widget.settings.chart.percentageMode});
                            }
                        },
                        yAxis: {
                            title: {
                                text: translationService.getLocalizedString('Results'),
                                align: 'middle',
                                offset: 15
                            }
                        },
                        plotOptions: {
                            bar: {
                                borderWidth: 0,
                                pointWidth: 28,
                                color: inputColor,
                                dataLabels: {
                                    enabled: false,
                                    formatter: function () {
                                        return Highcharts.numberFormat(this.percent) + '%';
                                    }
                                }
                            },
                            series: {
                                animation: doChartAnimation
                            }
                        }
                    };
                    var dashboardRequestData = data;
                    dashboardRequestData.series[0].data = dashboardRequestData.series[0].data.slice(0, 6);

                    scope.chartData = CoreCommon.mergeRecursive(scope.chartData, dashboardRequestData);
                    scope.chartData = CoreCommon.mergeRecursive(scope.chartData, baseChart);
                }
                scope.chartData = new CoreChartObject(chartBasics, scope.chartData);
                if(!graphInitialLoad) {
                    $timeout(function() {
                        scope.$broadcast('widgetRedraw');
                    }, 400);
                } else {
                    graphInitialLoad = false;
                }
            };

            scope.initSettings();
            if(!scope.readyToQuery) return;

            scope.highchart = true;
            scope.widgetIsLoading=true;
            scope.serviceError = false;
            scope.noDataFromServer = false;
            scope.notConfigured = false;
            scope.chartDataObject.insObject = scope.insightsService;
            scope.chartDataObject.dataMap = InsightsDataMaps.datamapCountryVolume;
            scope.chartDataObject.chartTransformFunction = TransformSegment[scope.graphType];
            scope.chartDataObject.queryParameters.size = 10;
            scope.chartDataObject.percent = scope.widget.settings.chart.percentageMode;

            if(scope.graphType == 'table') {
                // Callback for table view
                scope.chartDataObject.callback = function tableGeoCallback(data) {
                    if (data.table.length > 0 && !scope.chartDataObject.hasFetchedDataWithSourceIds && scope.inputs && scope.inputs[0].inputType === 'news') {
                        fetchAllDataWithSourceIds();
                    } else {
                        scope.tableSettings.data = data.table;
                        if(scope.widget.settings.chart.percentageMode === true){
                            scope.tableSettings.summary = data.percentSummary;
                            scope.tableSettings.displayField = scope.tableSettings.percentField;
                        } else {
                            scope.tableSettings.summary = data.countSummary;
                            scope.tableSettings.displayField = scope.tableSettings.countField;
                        }
                        scope.widgetIsLoading = false;
                        scope.tableSettings.drilldown = function drilldown(datapoint){

                            if(scope.searches.length > 0) {
                                scope.internalDrillDown(scope.searches[0]['agent'], datapoint.filterField);
                            }else{
                                scope.internalDrillDown(scope.inputs[0].id, datapoint.filterField);
                            }
                        };
                        scope.tableSettings.tooltip = function tooltip(datapoint){
                            return translationService.getLocalizedString('Top Sources') + ': ' + datapoint.count;
                        };
                        scope.showTable = true;

                    }
                }
            } else {
                scope.chartDataObject.callback = function barGeoCallback(data) {
                    createSourceIdMap(data);

                    if (data.series[0].data.length > 0 && !scope.chartDataObject.hasFetchedDataWithSourceIds && scope.inputs && scope.inputs[0].inputType === 'news') {
                        fetchAllDataWithSourceIds();
                    } else {
                        if ($routeParams.sourceId) {
                            updateBreadcrumb(getSourceNameFromSourceIdMap($routeParams.sourceId));
                        }
                        //GYDA-11045
                        // Added the piece to display: (unknown source) instead of the index number for source on top publication widget
                        if(data.xAxis && data.xAxis.categories){
                            for(var i=0;i<data.xAxis.categories.length;i++){
                                var category;
                                if(data.xAxis.categories[i] === null) {
                                    if(data.series && data.series[0] && data.series[0].data && data.series[0].data[i] && data.series[0].data[i].sourceId && data.series[0].data[i].sourceId !== '') {
                                        category = getSourceNameFromSourceIdMap(data.series[0].data[i].sourceId);
                                    } else {
                                        // We should never hit this case but it we do it will be nice to catch during dev and staging testing
                                        // If we display Unknown Source we know we have something else to address
                                        category = translationService.getLocalizedString("Unknown Source");
                                    }
                                } else {
                                    category = data.xAxis.categories[i];
                                }
                                data.xAxis.categories[i] = category;
                            }
                        }
                        scope.mwVizBarChartFeature = false;
                        const { percentageMode } = scope.widget.settings.chart;
                        if(!percentageMode) {
                            scope.mwVizBarChartFeature = true;
                            initMwBarChart(data);
                        } else {
                            processData(data);
                        }
                        scope.widgetIsLoading = false;
                        window.status = 'READY';
                    }
                };
            }

            //making a second call with the sourceIds to get accurate document counts which are synced with the content stream
            function fetchAllDataWithSourceIds() {
                var allSourceIds = '';
                Object.keys(sourceIdMap).forEach(function(key) {
                    if (key.startsWith('adhoc')) {
                        return;
                    }

                    allSourceIds += key + ',';
                });

                if (allSourceIds){
                    allSourceIds = allSourceIds.substring(0,allSourceIds.length-1);
                    scope.chartDataObject.queryParameters.source = allSourceIds;
                }

                scope.chartDataObject.hasFetchedDataWithSourceIds = true;

                ChartDataService.fetchAllData(scope.chartDataObject, scope.$id).catch(function onCatch(error) {
                    scope.$emit('chartData_fetchAllDataError', error);
                });
            }

            scope.chartDataObject.fetchDataForPreviousRange = true;

            ChartDataService.fetchAllData(scope.chartDataObject, scope.$id).catch(function onCatch(error) {
                scope.$emit('chartData_fetchAllDataError', error);
            });
        };
        if(scope.widget.hasRequiredSettings()){
            scope.fetchData();
        } else {
            scope.notConfigured=true;
        }

        scope.animate = true;
        scope.togglePercentage = function(id) {
            let percentageMode;

            scope.selectedLabelFormatId = id;
            if(id === 1) {
                percentageMode = false;
            } else if (id === 2) {
                percentageMode = true;
            }

            const showMwVizBarChart = !percentageMode && !scope.showTable && scope.mwVizBarChartFeature;

            scope.animate = false;
            scope.showMwVizBarChart = showMwVizBarChart;
            scope.widget.settings.chart.percentageMode = percentageMode;
            scope.fetchData();
        };

        var getSourceNameFromSourceIdMap = function getSourceNameFromSourceIdMap(id) {
            var sourceName = sourceIdMap[id];
            if(sourceName === null && id !== null && id !== '') {
                sourceName = id;
                // capitalize the first character for each word in the string
                var splitStr = sourceName.toLowerCase().split(' ');
                for (var i = 0; i < splitStr.length; i++) {
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
                sourceName = splitStr.join(' ');
            }
            return sourceName === null? translationService.getLocalizedString('Unknown Source') : sourceName;
        };

        scope.$on('$locationChangeSuccess', function onCoreBreadcrumbLocationChangeSuccess(event, newVal, oldVal) {
            var newParams = getRequestparams(newVal),
                oldParams = getRequestparams(oldVal);

            if(newVal == oldVal) {return;}

            if(oldParams.sourceId !== undefined && newParams.sourceId === undefined) {
                updateBreadcrumb();
                if(scope.documentRequest.source) {
                    delete scope.documentRequest.source;
                }
                InsWidgetConfigService.queryRequestSettings.source = null;
                InsWidgetConfigService.dateGranularityDrilldown(false, undefined, scope);
            } else if((newParams.sourceId !== undefined && oldParams.sourceId === undefined) || (newParams.sourceId !== undefined && oldParams.sourceId !== undefined && (newParams.sourceId !== oldParams.sourceId))) {
                // In this case, the user probably used the browser's Forward button to go back to a drilldown.
                // Since we don't have the benefit of a click trigger, we need to do it manually here
                updateBreadcrumb(getSourceNameFromSourceIdMap(newParams.sourceId));

                scope.documentRequest['source'] = newParams.sourceId;
                if(scope.searches.length > 0){
                    scope.drillDown(scope.searches[0].agent, undefined, scope);
                } else {
                    scope.drillDown(scope.inputs[0].id, undefined, scope);
                }
            }
        });

        var getRequestparams = function getRequestparams(url) {
            var params = {};
            var searchStr = url.split("?")[1];
            if(searchStr !== undefined) {
                var paramsStr = searchStr.split("&");
                for(var key in paramsStr) {
                    params[paramsStr[key].split("=")[0]] = paramsStr[key].split("=")[1];
                }
            }
            return params;
        };

        scope.internalDrillDown = function(id, sourceId, category){
            if(scope.isMaximized){
                var queryParams = {
                    drilled: true,
                    sourceId: sourceId
                };
                scope.documentRequest['source'] = sourceId;
                updateLocationURL(queryParams, category);
            }

            scope.drillDown(id,undefined,scope);
            if(scope.graphType !== 'table') {
                scope.$apply();
            }
        };

        var updateLocationURL = function updateLocationURL(queryParams, category) {
            var maxPath,
                editMode = $routeParams.editMode || false;
            if($location.path().indexOf('/dashboard/index') === 0) {
                maxPath = '/dashboard/viewer/'+DashboardStateService.getDefaultDashboard()+'/' + scope.widget.id;
            } else if($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new'){
                maxPath = $location.path();
            } else {
                maxPath = '/dashboard/'+($location.path().indexOf('builder') === -1?'viewer':'builder')+'/'+(DashboardStateService.currentDashboard._id || 'current') + '/' + scope.widget.id;
            }

            if(!$routeParams.drilled) {
                queryParams['drilled'] = true;
            }

            var urlQuery = {
                editMode:editMode
            };
            for(var prop in queryParams) {
                urlQuery[prop] = queryParams[prop]
            }
            updateBreadcrumb(category);
            $location.path(maxPath).search(urlQuery);
        };

        var updateBreadcrumb = function updateBreadcrumb(sourceName) {
            var dashboardPath,
            widgetPath,
            selectionTitle = '',
            dashboardMode = $location.path().indexOf('/dashboard/viewer') !== -1 ? '/dashboard/viewer/' : '/dashboard/builder/';

            scope.breadcrumbs =[];
            scope.breadcrumbs = [Breadcrumb.build({
                name: 'Analyze',
                link: '/analyze/home',
                isClickable: false
            })];
            dashboardPath = '/dashboard/viewer/' + scope.dashboard._id;

            selectionTitle += sourceName ? sourceName : '';

            scope.breadcrumbs.push(Breadcrumb.build({name:scope.dashboard.title, link:dashboardPath }));
            if(selectionTitle === '') {
            var mypath = '/dashboard/viewer/'+scope.dashboard._id,
                subCrumbs = [],
                myNewPath,
                subCrumbVal;

                if(scope.dashboard.containers[0].widgets.length > 1) {
                    Object.keys(scope.dashboard.containers[0].widgets).forEach(function(key){
                        myNewPath = dashboardMode + scope.dashboard._id + '/' + scope.dashboard.containers[0].widgets[key].id + '?editMode=false';
                        subCrumbVal = {
                            name: scope.dashboard.containers[0].widgets[key].title,
                            link: myNewPath,
                            isClickable: function isClickable() { return true; }
                        };

                        subCrumbs.push(subCrumbVal);
                    });
                }
                scope.breadcrumbs.push(Breadcrumb.build({name:scope.widget.title, subCrumbs:subCrumbs}));
            } else {
                widgetPath = dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false';
                scope.breadcrumbs.push(Breadcrumb.build({name:scope.widget.title, link: widgetPath}));
                scope.breadcrumbs.push(Breadcrumb.build({name:selectionTitle}));
            }
        };

        var resetBreadcrumb = function resetBreadcrumb() {
            var maxPath,
                editMode = $routeParams.editMode || false;
            if($location.path().indexOf('/dashboard/index') === 0) {
                maxPath = '/dashboard/viewer/'+DashboardStateService.getDefaultDashboard()+'/' + scope.widget.id;
            } else if($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new'){
                maxPath = $location.path();
            } else {
                maxPath = '/dashboard/'+($location.path().indexOf('builder') === -1?'viewer':'builder')+'/'+(DashboardStateService.currentDashboard._id || 'current') + '/' + scope.widget.id;
            }

            var urlQuery = {
                editMode:editMode
            };

            updateBreadcrumb();
            $location.path(maxPath).search(urlQuery);
        };

        scope.toggleGraph = function(graphType) {
            //on toggle we do not want existing click filter to be applied
            if(InsWidgetConfigService.queryRequestSettings.source){
                InsWidgetConfigService.queryRequestSettings.source = null;
            }
            var oldGraphType = scope.graphType;
            const mwVizBarChartFeature = !scope.widget.settings.chart.percentageMode && scope.mwVizBarChartFeature;
            scope.graphType = graphType;
            scope.showTable = false;
            scope.showMwVizBarChart = mwVizBarChartFeature;
            resetBreadcrumb();
            scope.fetchData();
        };

        scope.toggleTable = function() {
            //on toggle we do not want existing click filter to be applied
            if(InsWidgetConfigService.queryRequestSettings.source){
                InsWidgetConfigService.queryRequestSettings.source = null;
            }
            scope.graphType = 'table';
            scope.showMwVizBarChart = false;
            resetBreadcrumb();
            scope.fetchData();
        };
    };

    return new WidgetDirective(sourceSegmentWidget, sourceSegmentWidgetLink, sourceSegmentWidgetController);
}])
.run(['DashboardWidgetService', 'translationService', 'CoreCommon','InsWidgetConfigService', 'DASHBOARD_LEGACY_URL', function (DashboardWidgetService, translationService, CoreCommon, InsWidgetConfigService, DASHBOARD_LEGACY_URL) {
    DashboardWidgetService.register({
        name: translationService.getLocalizedString('Top Sources'),
        app: 'ins_dashboard',
        description: translationService.getLocalizedString('The Top Sources widget provides insight into how coverage of a brand, ' +
                                                            'product, event or topic is broken down by media outlet. The widget displays ' +
                                                            'a ranking of the top 10 sources where a topic is covered most frequently and ' +
                                                            'thereby helps you understand in which publications and social channels a topic is trending.'),
        directive: 'source-segment-widget',
        icon,
        defaultSettings: {
            'width': 'third',
            'title': 'Title',
            'description': '',
            source: [],
            'maxAgents': 1
        },
        displayOrder: 7,
        allowExport: true,
        requiredSettings: ['dateRange'],
        availableSettings: ['dateRange','title','news','social','tags','labelFormat', 'labelVisibility'],
        availableChartTypes:[{
            name:'Bar', id:'bar'
        }],
        getDefaultChartType: function() {
            if (CoreCommon.isUsable(this.settings.searchIds) && this.settings.searchIds.length !== 0) {
                return this.availableChartTypes[0];
            }
        },
        hasRequiredSettings: function(){
            var _widget = this;
            return InsWidgetConfigService.hasSelectedAnInput(_widget);
        },
        template,
        templateMaxView,
        templateReportView
    });

}]);
